import './FooterStyle.css'

const Footer = () => (
  <div className="footer">
    <p>Copyright &copy; {(new Date().getFullYear())} Realistic Development, LLC</p>
  </div>
);

export default Footer;